import { pluralize, userFullName } from "../utils";
import React from "react";
import { Avatar } from "../components";
import { useSchoolConfig } from "../hooks";
var RubricTable = function RubricTable(_ref) {
  var assignment = _ref.assignment,
    showStudents = _ref.showStudents,
    hidePoints = _ref.hidePoints,
    showScoreSelection = _ref.showScoreSelection;
  var rubrics = assignment === null || assignment === void 0 ? void 0 : assignment.rubrics;
  var assignmentObjectives = assignment === null || assignment === void 0 ? void 0 : assignment.assignment_objectives;
  var _useSchoolConfig = useSchoolConfig(),
    learningObjectiveLabel = _useSchoolConfig.learningObjectiveLabel;
  var isCellSelected = function isCellSelected(assignmentObjectiveId, cellId) {
    var _assignment$user_assi;
    var row = assignment === null || assignment === void 0 || (_assignment$user_assi = assignment.user_assignment) === null || _assignment$user_assi === void 0 ? void 0 : _assignment$user_assi.rubric_grades.find(function (item) {
      return item.ms_teams_assignment_objective_id === assignmentObjectiveId;
    });
    if (!row) return false;
    return row.mst_rubric_cell_id === cellId;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "table-responsive"
  }, /*#__PURE__*/React.createElement("table", {
    className: "table rounded table-bordered table-nurture-striped"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    className: "p-3",
    style: {
      minWidth: '250px',
      maxWidth: '250px'
    }
  }, learningObjectiveLabel), rubrics === null || rubrics === void 0 ? void 0 : rubrics[0].columns.map(function (column) {
    return /*#__PURE__*/React.createElement("th", {
      className: "p-3",
      style: {
        minWidth: '250px',
        maxWidth: '250px'
      },
      key: column.id
    }, /*#__PURE__*/React.createElement("div", {
      className: "d-flex justify-content-between"
    }, /*#__PURE__*/React.createElement("span", null, column.name), !hidePoints && /*#__PURE__*/React.createElement("span", {
      title: "".concat(column.point, " ").concat(pluralize('point', column.point)),
      className: "badge p-2 bg-nurture-navy-blue text-dark ms-2 text-white"
    }, column.point, " ", pluralize('point', column.point))));
  }))), /*#__PURE__*/React.createElement("tbody", null, rubrics === null || rubrics === void 0 ? void 0 : rubrics.map(function (rubric, index) {
    return /*#__PURE__*/React.createElement("tr", {
      className: "p-3"
    }, /*#__PURE__*/React.createElement("td", {
      className: "font-weight-600",
      style: {
        minWidth: '250px',
        maxWidth: '250px'
      }
    }, rubric['Learning Outcome']), rubric.columns.map(function (column) {
      var _assignmentObjectives;
      return /*#__PURE__*/React.createElement("td", {
        className: "p-3 ".concat(showScoreSelection ? 'selectable-student' : '', " ").concat(showScoreSelection && isCellSelected(rubric.id, column.cell_id) ? 'selected' : ''),
        style: {
          maxWidth: '250px'
        }
      }, /*#__PURE__*/React.createElement("span", null, column.value), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), showStudents && /*#__PURE__*/React.createElement("div", {
        className: "avatar-group d-sm-flex flex-wrap"
      }, !!(assignmentObjectives !== null && assignmentObjectives !== void 0 && (_assignmentObjectives = assignmentObjectives[index]) !== null && _assignmentObjectives !== void 0 && _assignmentObjectives['rubrics_grades']) && assignmentObjectives[index]['rubrics_grades'].map(function (grade) {
        var user = grade.user;
        if (user != null && grade.cell_id === column.cell_id) {
          return /*#__PURE__*/React.createElement(Avatar, {
            img: user.avatar_url,
            size: "xs",
            title: userFullName(user),
            key: user.id
          });
        }
      })));
    }));
  }))));
};
RubricTable.defaultProps = {
  showStudents: false,
  hidePoints: false,
  showScoreSelection: false
};
export default RubricTable;